import React, { useEffect, useState } from "react";
import { filter, includes, map } from "ramda";
import { useNavigate } from "react-router-dom";
import { useOrganizations } from "../../../user-admin/userServices";

import Skeleton from "@mui/material/Skeleton";

import ListSummaryCard from "../../common/ListSummaryCard";
import { capitalize } from "../../../util/stringFormat";

const pluralizeMediaType = mediaType => {
  switch (mediaType) {
    case "module":
      return "modules";
    case "anthology":
      return "anthologies";
    case "collection":
      return "collections";
    default:
      return mediaType;
  }
};

const OwnersList = ({ historyState = null, media, searchState }) => {
  const navigate = useNavigate();
  const organizations = useOrganizations();
  const [owners, setOwners] = useState([]);

  const mediaType = pluralizeMediaType(media.mediaType);
  const state = historyState ?? {
    label: `Back to ${capitalize(mediaType)}`,
    previousLocation: `/creator/${mediaType}`,
    search: {
      [mediaType]: searchState,
    },
  };

  useEffect(() => {
    if (organizations.isSuccess) {
      const owners = filter(
        org => includes(org.organizationId, media.owners),
        organizations.data,
      );
      setOwners(owners);
    }
  }, [media, organizations.isSuccess, organizations.data]);

  return organizations.isLoading ? (
    <Skeleton />
  ) : (
    <ListSummaryCard
      data={map(
        owner => ({
          id: owner.organizationId,
          name: owner.organizationName,
          handleClick: () =>
            navigate(
              `/manage-organizations/organizations/${owner.organizationId}`,
              { state: state },
            ),
        }),
        owners,
      )}
    />
  );
};

export default OwnersList;
